"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateTokens = generateTokens;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ykbColors = require("ykb-colors");
var _ykbUtils = require("ykb-utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// import { presetPalettes } from 'ykb-colors';

/** YKB COLORS: */
// generate,
// generatePalettes,
// presetPalettes,
// presetDarkPalettes,
// presetPrimaryColors,

// Tasarimcilardan Sparx icin de `volcano, orange, gold, lime, geekblue, purple, magenta` vermelerini isteyebiliriz.
// Su anda, bu renkleri Ant tan gelen default halleri ile biraktim
var presetDefaultPrimaryColors = {
  red: '#F24739',
  volcano: '#FA541C',
  orange: '#FA8C16',
  gold: '#FAAD14',
  yellow: '#FFAE19',
  lime: '#A0D911',
  green: '#26BA5C',
  cyan: '#17c6ff',
  blue: '#4691FB',
  geekblue: '#3960F1',
  purple: '#722ED1',
  magenta: '#EB2F96',
  grey: '#b4b4b4'
};
var cdnUrls = {
  tst: 'https://cdn-architecture-tst.cldnp.yapikredi.com.tr',
  uat: 'https://cdn-architecture-uat.cldnp.yapikredi.com.tr',
  liv: 'https://cdn-architecture.cld.yapikredi.com.tr',
  cloudFoundry: 'https://cdn-architecture-tst.cldnp.yapikredi.com.tr'
};
var env = 'cloudFoundry';
var cdnUrl = process.env.REACT_APP_ASSET_URL || "".concat(cdnUrls[env], "/static");
var bases = {
  fontSize: 14,
  borderRadius: 4,
  componentHeight: 40,
  componentPadding: 10,
  borderWidth: 1,
  borderStyle: 'solid'
};
var tokens = {
  cdn: {
    url: "".concat(cdnUrl),
    // Asset Folder
    fontUrl: "".concat(cdnUrl, "/fonts"),
    // Font Folder
    imageUrl: "".concat(cdnUrl, "/images"),
    // Image Folder
    // TODO: gerek olacak mi svg icon a gecince?
    iconUrl: "".concat(cdnUrl, "/icon") // Fonticon Folder
  },
  font: {
    family: 'OpenSans, Helvetica, Arial, sans-serif',
    size: "".concat(bases.fontSize, "px"),
    sizeLg: "".concat(bases.fontSize + 2, "px"),
    sizeSm: "".concat(bases.fontSize - 1, "px"),
    lineHeight: '14px',
    bodyLetterSpacing: '0.01em',
    variant: 'tabular-nums',
    featureSettings: 'tnum'
  },
  iconSizeBase: '24px',
  gutter: '10px',
  borderRadiusBase: "".concat(bases.borderRadius, "px"),
  borderRadiusSm: "".concat(bases.borderRadius - 2, "px"),
  component: {
    height: "".concat(bases.componentHeight, "px"),
    heightXs: "".concat(bases.componentHeight - 16, "px"),
    heightSm: "".concat(bases.componentHeight - 10, "px"),
    heightLg: "".concat(bases.componentHeight + 10, "px"),
    padding: "".concat(bases.componentPadding, "px"),
    padding2x: "".concat(bases.componentPadding * 2, "px")
  },
  shadow: {
    color: 'rgba(0, 0, 0, 0.15)'
  },
  colorType: {
    primary: 'blue',
    //blue6
    info: 'blue',
    //blue6
    secondary: 'cyan',
    //cyan6
    default: 'grey',
    //grey6
    success: 'green',
    //green6
    warning: 'yellow',
    //yellow6
    danger: 'red',
    // red6
    error: 'red',
    //red6
    neutral: 'neutral'
    //volcano, lime vs. de eklenebilir eger projede kullanilacaksa
  },
  zIndex: {
    affix: 10,
    select: 1050,
    notification: 1010,
    modal: 1000,
    modalMask: 1000,
    dropdown: 1050,
    message: 1010,
    popover: 1030,
    picker: 1050,
    tooltip: 1060
  },
  device: {
    small: '730px',
    medium: '950px',
    large: '1180px',
    // 1200 - gutter * 2
    xlarge: '1420px'
  },
  responsive: {
    small: '(min-width: 768px)',
    medium: '(min-width: 992px)',
    large: '(min-width: 1200px)',
    xlarge: '(min-width: 1440px)',
    xsmallMax: '(max-width: 767px)',
    smallMax: '(max-width: 991px)',
    mediumMax: '(max-width: 1199px)'
  },
  input: {
    editableCurrency: {
      margin: '0 -10px'
    },
    sizes: {
      small: {
        editableCurrencyWidth: '56px',
        editableCurrencyFontSize: '13px',
        copyIconSize: '16px',
        editableCurrencyHeight: '28px'
      },
      medium: {
        editableCurrencyWidth: '62px',
        editableCurrencyFontSize: '14px',
        copyIconSize: '24px',
        editableCurrencyHeight: '38px'
      },
      large: {
        editableCurrencyWidth: '66px',
        editableCurrencyFontSize: '14px',
        copyIconSize: '24px',
        editableCurrencyHeight: '48px'
      }
    },
    allowClear: {
      borderRight: "".concat(bases.borderWidth, "px ").concat(bases.borderStyle, " rgba(0, 0, 0, 0.0)")
    },
    phoneInput: {
      dialCodeAddon: {
        width: '70px'
      }
    },
    numberInput: {
      width: '100%'
    }
  },
  pagination: {
    fontSize: '13px',
    itemSize: '24px',
    itemSizeSm: '22px',
    lineHeightSm: '20px',
    // itemSizeSm - 2px
    itemSizeLg: '32px',
    lineHeightLg: '28px',
    // itemSizeLg - 4px
    jumpHeightLg: '24px' // itemSizeLg - 8px
  },
  upload: {
    multipleUpload: {
      height: '100%'
    }
  },
  calendar: {
    card: {
      width: '100%',
      date: {
        height: '32px',
        day: {
          height: '24px',
          lineHeight: '18px',
          fontSize: '13px'
        }
      },
      footer: {
        button: {
          width: '100%',
          marginBottom: '5px'
        },
        badge: {
          marginLeft: '8px'
        }
      }
    }
  },
  select: {
    addon: {
      fontSize: '14px',
      padding: '10px',
      border: "".concat(bases.borderWidth, "px ").concat(bases.borderStyle, " rgb(180, 180, 180)"),
      after: {
        borderRadius: '0px 4px 4px 0px'
      },
      before: {
        borderRadius: '4px 0px 0px 4px'
      }
    },
    selectedIconSize: {
      small: '16px',
      medium: '24px',
      large: '26px'
    }
  },
  table: {
    draggable: {
      column: {
        icon: {
          width: 30
        }
      }
    },
    selection: {
      selectAll: {
        marginRight: '8px',
        padding: '8px 3px 8px 0',
        label: {
          marginRight: '2px'
        }
      }
    }
  },
  tableHeader: {
    button: {
      text: {
        marginLeft: '5px'
      }
    }
  },
  form: {
    label: {
      fontSize: '14px'
    }
  },
  checkbox: {
    label: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.5
    }
  },
  radio: {
    label: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.5
    }
  },
  button: {
    size: {
      xsmall: {
        paddingWithIcons: '3px'
      },
      small: {
        paddingWithIcons: '4px'
      },
      medium: {
        paddingWithIcons: '7px'
      },
      large: {
        paddingWithIcons: '11px'
      }
    }
  }
};
function addDefaultPalette(colorPalette, types) {
  var newPalette = {};
  for (var _i = 0, _Object$keys = Object.keys(types); _i < _Object$keys.length; _i++) {
    var color = _Object$keys[_i];
    var size = color === 'neutral' ? 13 : 10;
    for (var i = 1; i <= size; i++) {
      newPalette["".concat(color).concat(i)] = colorPalette["".concat(types[color]).concat(i)];
    }
  }
  return newPalette;
}

/**
 * params Object may have tokens and colors properties if provided
 * @param params
 * @returns {object}
 */
function generateTokens(params) {
  var providedColors = params && params.colors ? (0, _ykbUtils.mergeDeep)(presetDefaultPrimaryColors, params.colors) : presetDefaultPrimaryColors;
  var providedTokens = params && params.tokens || {};
  var providedColorTypes = params && params.tokens.colorType || tokens.colorType;
  return _objectSpread({
    colorPalette: (0, _ykbColors.generatePalettes)(providedColors),
    color: addDefaultPalette((0, _ykbColors.generatePalettes)(providedColors), providedColorTypes),
    presetColors: providedColors
  }, (0, _ykbUtils.mergeDeep)(tokens, providedTokens));
}